import React from 'react';
import { useNavigate } from 'react-router';
import { Container } from '@mui/material';
import { Svg } from 'assets';
import { LAST_UPDATED, PRIVACY_SECTIONS } from './constants';
import { renderBlock } from './fragments';

export const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-condition">
      <div className="privacy-page">
        <Container maxWidth="lg">
          <button style={{ marginBottom: 12 }} className="back-btn" onClick={() => navigate('/')}>
            <Svg.ArrowLeftBack />
            Back
          </button>
          <div className="page-info">
            <div className="title-box">
              <h3 className="privacy-title">CareTech Privacy Policy</h3>
              <p className="privacy-last-updated">Last Updated: {LAST_UPDATED}</p>
            </div>
            <div className="privacy-body">
              <p className="privacy-text">
                CareTech ("CareTech," "we," "us," or "our") respects your privacy and is committed to protecting
                personal information processed through our website, web application, mobile application, and related
                services (collectively, the "Services").
              </p>
              <p className="privacy-text">
                This Privacy Policy explains what information we collect, how we use and share it, how we protect it,
                how long we retain it, and how users can request deletion of their personal information.
              </p>
              <p className="privacy-text">
                By accessing or using the Services, you acknowledge the practices described in this Privacy Policy.
              </p>

              {PRIVACY_SECTIONS.map((section, sIndex) => (
                <div key={sIndex} className="privacy-section">
                  <h4 className="privacy-section-title">{section.title}</h4>
                  {section.content.map((block, bIndex) => renderBlock(block, bIndex))}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
